import { DealTrade } from '@pages/Deal/types';

export enum ValuationCheckStatus {
  Complete = 'COMPLETE',
  Failed = 'FAILED',
  Retrying = 'RETRYING',
}

export enum PricingUpdateFrequency {
  Daily = 'DAILY',
  Weekly = 'WEEKLY',
  Fortnightly = 'FORTNIGHTLY',
  Monthly = 'MONTHLY',
}

export enum PricingUpdateScheduleStatus {
  Active = 'ACTIVE',
  Ended = 'ENDED',
}

// Latest valuation of a scheduled trade; trade details are joined client-side
// from the deal's trades (see selectPricingUpdateTrades)
export interface PricingUpdateValuation {
  transaction_id: number;
  valuation_status: ValuationCheckStatus | null;
  par_coupon: number | null;
  // market data that could not be sourced, set when the valuation failed
  valuation_error: string | null;
}

export type PricingUpdateTrade = DealTrade & PricingUpdateValuation;

export interface PricingUpdateSchedule {
  id: number;
  gold_vision_id: number;
  status: PricingUpdateScheduleStatus;
  email_start: string;
  email_end: string;
  frequency: PricingUpdateFrequency;
  next_send: string | null;
  recipients: string[];
  trades: PricingUpdateValuation[];
}

export interface PricingUpdateRun {
  id: number;
  send_date: string;
  recipients_count: number;
  trades_priced: number;
  sent: boolean;
  // why the run was not sent, only set when sent is false
  failure_reason: string | null;
}

// One business day's valuation of a trade, failures included
export interface ParCouponHistoryEntry {
  valuation_date: string;
  curve_date: string;
  par_coupon: number | null;
  change_bps: number | null;
  valuation_status: ValuationCheckStatus;
  // why the valuation failed, set when valuation_status is Failed
  valuation_error: string | null;
}

export interface GetParCouponHistoryPayload {
  transaction_id: number;
}

export interface PricingUpdateContact {
  email: string;
  name: string | null;
}

export interface PricingUpdatePreview {
  html: string;
  included_trades: number;
  excluded_trades: number;
}

// One line per deal for the Deal Centre tiles, so the list does not have to
// pull a full schedule per card
export interface PricingUpdateSummary {
  gold_vision_id: number;
  frequency: PricingUpdateFrequency;
  trade_count: number;
  failed_count: number;
  next_send: string | null;
}

export interface GetPricingUpdateSummariesPayload {
  gold_vision_ids: number[];
}

export interface GetPricingUpdateSchedulePayload {
  gold_vision_id: number;
}

export interface SavePricingUpdateSchedulePayload {
  gold_vision_id: number;
  schedule_id?: number;
  email_start: string;
  email_end: string;
  frequency: PricingUpdateFrequency;
  recipients: string[];
  transaction_ids: number[];
}

export interface PricingUpdateSchedulePayload {
  schedule_id: number;
}

export interface PricingUpdateTradePayload
  extends PricingUpdateSchedulePayload {
  transaction_id: number;
}
